<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import router from '@/router'
import Layout from '@/views/layout/Layout'
import enquireScreen from '@/util/device'
import {
  findMenuColTree, // 获取树
} from '@/api/index'
import { constRouter } from '@/router'
// console.log('constRouter----', constRouter)
export default {
  name: 'App',
  created() {
    findMenuColTree().then((res) => {
      window.sessionStorage.routerRes = JSON.stringify(res.data)
      let resObj = this.setRouter(res.data)
      // resObj = resObj.concat(constRouter)
      window.sessionStorage.indexNavList = JSON.stringify(resObj.navList)
      router.addRoutes(resObj.addRoutersArr)
      router.options.routes = resObj.addRoutersArr
      this.navList = JSON.parse(window.sessionStorage.indexNavList)
      console.log(this.navList)
    })

    // 适配
    let that = this
    enquireScreen((deviceType) => {
      // tablet
      if (deviceType === 0) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        // that.$store.dispatch('setSidebar', false)
      }
      // mobile
      else if (deviceType === 1) {
        that.$store.commit('TOGGLE_DEVICE', 'mobile')
        // that.$store.dispatch('setSidebar', false)
      } else {
        that.$store.commit('TOGGLE_DEVICE', 'desktop')
        // that.$store.dispatch('setSidebar', true)
      }
    })
  },
  methods: {
    setRouter(routerRes) {
      let addRoutersArr = []
      let navList = []
      for (let item of routerRes) {
        if (item.title == '首页') {
          // 导航
          let navObj = {
            label: `${item.title}`,
            linkUrl: `/index`,
          }
          navList.push(navObj)

          // 路由
          let routerObj = {
            path: '/',
            component: Layout,
            // name: 'index',
            redirect: 'index',
            children: [
              {
                path: 'index',
                meta: {
                  title: '首页',
                  id: item.id,
                },
                component: () => import('@/views/index/index'),
                name: '首页',
              },
            ],
          }
          addRoutersArr.push(routerObj)

          // 首页其他
          console.log('首页数据', item)
          for (let indexItem of item.children) {
            // 列表，详情方式
            let routerObj = {
              path: `/${indexItem.keyWords}`,
              component: Layout,
              redirect: `/${indexItem.keyWords}/list`,
              children: [
                {
                  path: 'list',
                  name: `${indexItem.title}`,
                  meta: {
                    title: `${indexItem.title}`,
                    id: indexItem.id,
                  },
                  component: () => import('@/views/rightStrList'),
                },
                {
                  path: 'info/:id',
                  name: `${indexItem.title}详情`,
                  meta: {
                    title: `${indexItem.title}详情`,
                    hidden: true,
                    id: indexItem.id,
                  },
                  component: () => import('@/views/rightRichText'),
                },
              ],
            }
            addRoutersArr.push(routerObj)
          }
        } else {
          if (item.children.length == 0) {
            // 导航
            let navObj = {
              label: `${item.title}`,
              linkUrl: `/${item.keyWords}/list`,
            }
            navList.push(navObj)

            // 路由
            let routerObj = {
              path: `/${item.keyWords}`,
              component: Layout,
              redirect: `/${item.keyWords}/list`,
              children: [
                {
                  path: 'list',
                  name: `${item.title}`,
                  meta: {
                    title: `${item.title}`,
                    id: item.id,
                  },
                  component: () => import('@/views/rightStrList'),
                },
                {
                  path: 'info/:id',
                  name: `${item.title}详情`,
                  meta: {
                    title: `${item.title}详情`,
                    hidden: true,
                    id: item.id,
                  },
                  component: () => import('@/views/rightRichText'),
                },
              ],
            }
            addRoutersArr.push(routerObj)
          } else {
            // 导航
            let navObj = {
              label: `${item.title}`,
              linkUrl: `/${item.keyWords}`,
            }
            navList.push(navObj)
            // 路由
            let routerObj1 = {
              path: `/${item.keyWords}`,
              component: Layout,
              meta: {
                title: `${item.title}`,
                id: item.id,
              },
              name: `${item.title}`,
              redirect: `/${item.keyWords}/${item.children[0].keyWords}/list`,
              children: [],
            }
            for (let itemChildren of item.children) {
              // 非 列表，详情方式
              if (itemChildren.title == '物业企业承诺书申报') {
                let listObj = {
                  path: `${itemChildren.keyWords}`,
                  name: `${itemChildren.title}`,
                  meta: {
                    title: `${itemChildren.title}`,
                    id: itemChildren.id,
                  },
                  component: () => import('@/views/enterpriseCommitmentDeclare/index'),
                }

                routerObj1.children.push(listObj)
              } else if (itemChildren.title == '已签订公约企业' || itemChildren.title == '未签订公约企业') {
                let listObj = {
                  path: `${itemChildren.keyWords}`,
                  name: `${itemChildren.title}`,
                  meta: {
                    title: `${itemChildren.title}`,
                    id: itemChildren.id,
                  },
                  component: () => import('@/views/rightTableTemp'),
                }

                routerObj1.children.push(listObj)
              } else {
                // 列表，详情方式
                let listObj = {
                  path: `${itemChildren.keyWords}/list`,
                  name: `${itemChildren.title}`,
                  meta: {
                    title: `${itemChildren.title}`,
                    id: itemChildren.id,
                  },
                  component: () => import('@/views/rightStrList'),
                }
                let infoObj = {
                  path: `${itemChildren.keyWords}/info/:id`,
                  name: `${itemChildren.title}详情`,
                  meta: {
                    title: `${itemChildren.title}详情`,
                    hidden: true,
                    id: itemChildren.id,
                  },
                  component: () => import('@/views/rightRichText'),
                }
                routerObj1.children.push(listObj)
                routerObj1.children.push(infoObj)
              }
            }
            addRoutersArr.push(routerObj1)
          }
        }
      }
      return {
        addRoutersArr,
        navList,
      }
    },
  },
}
</script>

<style>
#app {
  font-family: '微软雅黑';
  color: #666;
  background: #f5f5f5;
  box-sizing: border-box;
}
div {
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue